export class Rectangle {
    x: number;
    y: number;
    width: number;
    height: number;
    
    constructor(x:number, y:number, width:number, height:number) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    
    getMiddle() {
        return this.y + this.height / 2;
    }
    
    getCenter() {
        return this.x + this.width / 2;
    }

    contains (point:{x:number, y:number}) {
        return (point.x > this.x && point.x < this.x + this.width)
            && (point.y > this.y && point.y < this.y + this.height);

    }
}
